import { KzIconBuilding, KzIconGlobe } from '@kaizenplatform/kaizen-icon-elements';

export const registerCustomElements = (registry: CustomElementRegistry) => {
  registry.define(KzIconBuilding.is, KzIconBuilding), registry.define(KzIconGlobe.is, KzIconGlobe);
};
